module.exports = __webpack_public_path__ + "img/Friends.340eb050.png";